import React from 'react';
import { TextField, Paper, Typography, styled } from '@material-ui/core';
import { CustomerModel } from '@/models/customer';

const StyledPaper = styled(Paper)({
	padding: '20px',
	marginBottom: '30px',
});

interface Props {
	customer: CustomerModel
	formEnabled: boolean
}

export const Other = (props: Props) => {
	return (
		<StyledPaper>
			<Typography variant="h4" component="h4">Other</Typography>

			<form noValidate autoComplete="off">
				<TextField
					name="gender"
					type="text"
					value={props.customer.gender}
					InputProps={{
						readOnly: !props.formEnabled,
					}}
					label="Gender"
					variant="outlined"
				/>

				<TextField
					name="languageCode"
					type="text"
					value={props.customer.languageCode}
					InputProps={{
						readOnly: !props.formEnabled,
					}}
					label="Language"
					variant="outlined"
				/>
			</form>
		</StyledPaper>
	);
};
